"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypoComp = exports.STYLED_ELLIPSIS_SANS_3 = exports.STYLED_ELLIPSIS_SANS_2 = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var mixins_1 = require("../../../themes/mixins");
var Typo_1 = require("../../Typo");
exports.STYLED_ELLIPSIS_SANS_2 = (0, styled_components_1.default)(Typo_1.SANS_2)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), mixins_1.ellipsis);
exports.STYLED_ELLIPSIS_SANS_3 = (0, styled_components_1.default)(Typo_1.SANS_3)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), mixins_1.ellipsis);
var getTypoComp = function (size) {
    return size === 'XS'
        ? function (props) { return (react_1.default.createElement(exports.STYLED_ELLIPSIS_SANS_2, __assign({}, props))); }
        : function (props) { return (react_1.default.createElement(exports.STYLED_ELLIPSIS_SANS_3, __assign({ semibold: true }, props))); };
};
exports.getTypoComp = getTypoComp;
var templateObject_1, templateObject_2;
